import { module } from 'modujs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: "toggle"
        }
    }

    init() {
        if (window.location.hash === '#' + this.el.id) {
            this.call('toggle', null, 'ModalGetInTouch')
        }
    }

    toggle() {
        this.call('updateAnchor', {obj: this, way: 'enter'}, 'Scroll')
        this.call('toggle', null, 'ModalGetInTouch')
    }
}
